import { render, staticRenderFns } from "./order_types.vue?vue&type=template&id=2ddf5700&scoped=true&"
import script from "./order_types.vue?vue&type=script&lang=js&"
export * from "./order_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf5700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddf5700')) {
      api.createRecord('2ddf5700', component.options)
    } else {
      api.reload('2ddf5700', component.options)
    }
    module.hot.accept("./order_types.vue?vue&type=template&id=2ddf5700&scoped=true&", function () {
      api.rerender('2ddf5700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_types.vue"
export default component.exports